module.exports = {
  patron: require("./patron"),
  clinician: require("./clinician"),
  meetingRoom: require("./meetingRoom"),
  reports: require("./reports"),
};
